exports.Data =  {
    "tables":{
        "Medication":[
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Rx Name": "ASA ",
              "Rx Type": "NSAIDS ",
              "Start Date": "04/13/2010 ",
              "End Date": "",
              "Rx Date": "05/29/2015 ",
              "Page": 243,
              "FIELD9": ""
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Depression ",
              "Rx Name": "CITALOPRAM HYDROBROMIDE ",
              "Rx Type": "Selective Serotonin-Reuptake Inhibitors ",
              "Start Date": "01/23/2015 ",
              "End Date": "",
              "Rx Date": "05/29/2015 ",
              "Page": 243,
              "FIELD9": ""
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Rx Name": "COREG CR ",
              "Rx Type": "Beta-Adrenergic Blocking Agents ",
              "Start Date": "05/29/2015 ",
              "End Date": "",
              "Rx Date": "05/29/2015 ",
              "Page": 243,
              "FIELD9": ""
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Rx Name": "COZAAR ",
              "Rx Type": "Angiotensin II Receptor Antagonist ",
              "Start Date": "10/04/2012 ",
              "End Date": "",
              "Rx Date": "05/29/2015 ",
              "Page": 243,
              "FIELD9": ""
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hyperlipidemia ",
              "Rx Name": "CRESTOR ",
              "Rx Type": "HMG CoA-Reductase Inhibitors (Statins) ",
              "Start Date": "10/04/2012 ",
              "End Date": "",
              "Rx Date": "05/29/2015 ",
              "Page": 243,
              "FIELD9": ""
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Rx Name": "FUROSEMIDE ",
              "Rx Type": "Loop Diuretics ",
              "Start Date": "09/09/2010 ",
              "End Date": "",
              "Rx Date": "05/29/2015 ",
              "Page": 243,
              "FIELD9": ""
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Rx Name": "NAMENDA XR ",
              "Rx Type": "N-Methyl-D-Aspartate (NMDA) Receptor AntAgonist ",
              "Start Date": "06/18/2009 ",
              "End Date": "",
              "Rx Date": "05/29/2015 ",
              "Page": 243,
              "FIELD9": ""
            },
            {
              "Impairment Category": "Gastrointestinal ",
              "Impairment": "GERD ",
              "Rx Name": "OMEPRAZOLE ",
              "Rx Type": "PPI ",
              "Start Date": "06/18/2009 ",
              "End Date": "",
              "Rx Date": "05/29/2015 ",
              "Page": 243,
              "FIELD9": ""
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Rx Name": "PLAVIX ",
              "Rx Type": "Anti-Platelet ",
              "Start Date": "04/13/2010 ",
              "End Date": "",
              "Rx Date": "05/29/2015 ",
              "Page": 243,
              "FIELD9": ""
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Rx Name": "VITAMIN B12 ",
              "Rx Type": "Vitamins ",
              "Start Date": "10/16/2009 ",
              "End Date": "",
              "Rx Date": "05/29/2015 ",
              "Page": 243,
              "FIELD9": ""
            },
            {
              "Impairment Category": "Gastrointestinal ",
              "Impairment": "GERD ",
              "Rx Name": "DEXILANT ",
              "Rx Type": "Proton-Pump Inhibitors ",
              "Start Date": "01/01/1900 ",
              "End Date": "",
              "Rx Date": "05/12/2015 ",
              "Page": 220,
              "FIELD9": ""
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Rx Name": "MVI ",
              "Rx Type": "Vitamins ",
              "Start Date": "01/01/1900 ",
              "End Date": "",
              "Rx Date": "05/12/2015 ",
              "Page": 221,
              "FIELD9": ""
            },
            {
              "Impairment Category": "Gastrointestinal ",
              "Impairment": "GERD ",
              "Rx Name": "PEPCID ",
              "Rx Type": "Histamine H2-Antagonists ",
              "Start Date": "01/01/1900 ",
              "End Date": "",
              "Rx Date": "05/12/2015 ",
              "Page": 220,
              "FIELD9": ""
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Rx Name": "EXELON ",
              "Rx Type": "Parasympathomimetic (Cholinergic) Agents ",
              "Start Date": "07/30/2009 ",
              "End Date": "",
              "Rx Date": "03/17/2014 ",
              "Page": 253,
              "FIELD9": ""
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Rx Name": "CARVEDILOL ",
              "Rx Type": "Beta-Adrenergic Blocking Agents ",
              "Start Date": "04/13/2010 ",
              "End Date": "",
              "Rx Date": "04/13/2010 ",
              "Page": 157,
              "FIELD9": ""
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Arrhythmias ",
              "Rx Name": "COUMADIN ",
              "Rx Type": "Coumarin Derivative ",
              "Start Date": "04/13/2010 ",
              "End Date": "",
              "Rx Date": "04/13/2010 ",
              "Page": 157,
              "FIELD9": ""
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Rx Name": "LISINOPRIL ",
              "Rx Type": "Angiotensin-Converting Enzyme (Ace) Inhibitors ",
              "Start Date": "04/13/2010 ",
              "End Date": "",
              "Rx Date": "04/13/2010 ",
              "Page": 157,
              "FIELD9": ""
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hyperlipidemia ",
              "Rx Name": "SIMVASTATIN ",
              "Rx Type": "HMG CoA-Reductase Inhibitors (Statins) ",
              "Start Date": "04/13/2010 ",
              "End Date": "",
              "Rx Date": "04/13/2010 ",
              "Page": 157,
              "FIELD9": ""
            }
           ],
        "Lifestyle": [
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "sedentary ",
              "Feature": "Activity level ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "sedentary ",
              "Expanded Value": "Sedentary activity level ",
              "Page": 243
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Driving ability ",
              "Feature": "Driving ability ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "not driving ",
              "Expanded Value": "Not driving, per HPI ",
              "Page": 241
            },
            {
              "Impairment Category": "Family History ",
              "Impairment": "Family history Longevity ",
              "Feature": "Family history of longevity-Father ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "92",
              "Expanded Value": "father-deceased at 92, old age ",
              "Page": 242
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "alcohol-None ",
              "Feature": "Alcohol use ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "none ",
              "Expanded Value": "No history of alcohol use ",
              "Page": 243
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Appearance ",
              "Feature": "Appearance ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "well-developed ",
              "Expanded Value": "Well developed, per physical exam ",
              "Page": 245
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Sleep hygiene ",
              "Feature": "Sleep hygiene ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "sleeps well ",
              "Expanded Value": "He sleeps well most nights ",
              "Page": 241
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "never smoker ",
              "Feature": "Smoking ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Never smoker ",
              "Expanded Value": "Never smoker ",
              "Page": 243
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Depression ",
              "Feature": "Depression ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "noted with no details ",
              "Expanded Value": "Depressive disorder, not elsewhere classified, controlled ",
              "Page": 241
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Falls ",
              "Feature": "Falls ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "fall with complications ",
              "Expanded Value": "Fell three months ago and injured the left shoulder, has been harder to use, trouble getting a shirt on an still a little sore, per HPI ",
              "Page": 242
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Falls ",
              "Feature": "Falls ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "fall with minor injury ",
              "Expanded Value": "Fell three months ago and injured the left shoulder, has been harder to use, trouble getting a shirt on an still a little sore, per HPI ",
              "Page": 242
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Immunization ",
              "Feature": "Immunization ",
              "Report Date": "05/29/2015 ",
              "Event Date": "10/01/2014",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "flu high dose ",
              "Expanded Value": "Influenza, high dose on 10/01/2014 ",
              "Page": 245
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Immunization ",
              "Feature": "Immunization ",
              "Report Date": "05/29/2015 ",
              "Event Date": "05/29/2015 ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "pneumococcal ",
              "Expanded Value": "Pneumococcal conjugate on 05/29/2015 ",
              "Page": 245
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Office visit frequency ",
              "Feature": "Office visit frequency ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "2",
              "Expanded Value": "2015: 1 office visit and 2014: 3 office visit ",
              "Page": 250
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Sensory losses ",
              "Feature": "Sensory losses ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "hearing ",
              "Expanded Value": "Lost hearing in left ear and has ringing in that ear, per HPI ",
              "Page": 242
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Preventive care ",
              "Feature": "Yearly preventive/screening exams ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Yes ",
              "Expanded Value": "Follow up for regular office visit ",
              "Page": 250
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Family involvement ",
              "Feature": "Family involvement in medical care ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "attend visits ",
              "Expanded Value": "Accompanied by his wife today, per HPI ",
              "Page": 241
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Spouse status ",
              "Feature": "Spouse status ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Living ",
              "Expanded Value": "Currently married ",
              "Page": 243
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Active ",
              "Feature": "Activity level ",
              "Report Date": "05/12/2015",
              "Event Date": "",
              "Clinician Name": "Clark McKenzia, MD ",
              "Clinician Specialty": "General ",
              "Value": "inactive ",
              "Expanded Value": "He is not active and will not walk the dog ",
              "Page": 219
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Appearance ",
              "Feature": "Appearance ",
              "Report Date": "05/12/2015",
              "Event Date": "",
              "Clinician Name": "Clark McKenzia, MD ",
              "Clinician Specialty": "General ",
              "Value": "well-nourished ",
              "Expanded Value": "Well nourished, per physical exam ",
              "Page": 221
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Sleep hygiene ",
              "Feature": "Sleep hygiene ",
              "Report Date": "05/12/2015",
              "Event Date": "",
              "Clinician Name": "Clark McKenzia, MD ",
              "Clinician Specialty": "General ",
              "Value": "1-3 hours/day ",
              "Expanded Value": "Will sleep during the day for 2-3 hours at time ",
              "Page": 219
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Sleep hygiene ",
              "Feature": "Sleep hygiene ",
              "Report Date": "05/12/2015",
              "Event Date": "",
              "Clinician Name": "Clark McKenzia, ",
              "Clinician Specialty": "General ",
              "Value": "sleeps poorly ",
              "Expanded Value": "Sleeps poorly at night with bad ",
              "Page": 219
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Pets ",
              "Feature": "Pets ",
              "Report Date": "05/12/2015",
              "Event Date": "",
              "Clinician Name": "Clark McKenzia, MD ",
              "Clinician Specialty": "General ",
              "Value": "Yes ",
              "Expanded Value": "He is not active and will not walk the dog ",
              "Page": 219
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Immunization ",
              "Feature": "Immunization ",
              "Report Date": "04/17/2015 ",
              "Event Date": "10/01/2013",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "flu ",
              "Expanded Value": "Flu (split) (3 yrs or older) 10/01/2013 ",
              "Page": 250
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Immunization ",
              "Feature": "Immunization ",
              "Report Date": "04/17/2015 ",
              "Event Date": "09/01/2011",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "flu ",
              "Expanded Value": "Flu (split) (3 yrs or older) 09/01/2011 ",
              "Page": 250
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Immunization ",
              "Feature": "Immunization ",
              "Report Date": "04/17/2015 ",
              "Event Date": "10/12/2010",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "flu ",
              "Expanded Value": "Flu (split) (3 yrs or older) 10/12/2010 ",
              "Page": 250
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Immunization ",
              "Feature": "Immunization ",
              "Report Date": "04/17/2015 ",
              "Event Date": "09/18/2008 ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "flu ",
              "Expanded Value": "Flu (split) (6 35 mos) 09/18/2008 ",
              "Page": 250
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Immunization ",
              "Feature": "Immunization ",
              "Report Date": "04/17/2015 ",
              "Event Date": "09/18/2008 ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "pneumococcal ",
              "Expanded Value": "Pneumo (2 yrs or older) (PPV23) 09/18/2008 ",
              "Page": 250
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Immunization ",
              "Feature": "Immunization ",
              "Report Date": "04/17/2015 ",
              "Event Date": "11/17/2013 ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Shingles ",
              "Expanded Value": "Zoster 11/17/2013 ",
              "Page": 250
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Immunization ",
              "Feature": "Immunization ",
              "Report Date": "04/17/2015 ",
              "Event Date": "06/18/2007 ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Td/Tdap ",
              "Expanded Value": "Td (adult) 06/18/2007 ",
              "Page": 250
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Pain ",
              "Feature": "Pain ",
              "Report Date": "03/17/2014 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "arthritic pain ",
              "Expanded Value": "Joint pain, per ROS ",
              "Page": 253
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Sleep hygiene ",
              "Feature": "Sleep hygiene ",
              "Report Date": "03/25/2013 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "nocturia ",
              "Expanded Value": "Nocturia, per ROS ",
              "Page": 2
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Bladder function ",
              "Feature": "Bladder function ",
              "Report Date": "03/25/2013 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "nocturia ",
              "Expanded Value": "Nocturia, per ROS ",
              "Page": 2
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Family involvement ",
              "Feature": "Family involvement in medical care ",
              "Report Date": "03/25/2013 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "attend visits ",
              "Expanded Value": "Accompanied by wife, per HPI ",
              "Page": 1
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Driving ability ",
              "Feature": "Driving ability ",
              "Report Date": "09/28/2012 ",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "not driving ",
              "Expanded Value": "He is not not driving, per HPI ",
              "Page": 9
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Sleep hygiene ",
              "Feature": "Sleep hygiene ",
              "Report Date": "09/28/2012 ",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "nocturia ",
              "Expanded Value": "Nocturia X 1, per HPI ",
              "Page": 9
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Bladder function ",
              "Feature": "Bladder function ",
              "Report Date": "09/28/2012 ",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "nocturia ",
              "Expanded Value": "Nocturia X 1, per HPI ",
              "Page": 9
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Immunization ",
              "Feature": "Immunization ",
              "Report Date": "09/28/2012 ",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "flu ",
              "Expanded Value": "Flu vaccine given ",
              "Page": 13
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "fatigue ",
              "Feature": "Fatigue ",
              "Report Date": "03/27/2012 ",
              "Event Date": "",
              "Clinician Name": "Clark R ***, MD ",
              "Clinician Specialty": "General ",
              "Value": "fatigue ",
              "Expanded Value": "Other malaise and fatigue, per diagnosis ",
              "Page": 52
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Home care ",
              "Feature": "Home Care ",
              "Report Date": "03/05/2012",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "companion ",
              "Expanded Value": "Have a live in Companion named Dan ",
              "Page": 15
            },
            {
              "Impairment Category": "Gastrointestinal ",
              "Impairment": "Home care ",
              "Feature": "Home Care ",
              "Report Date": "03/05/2012",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "home health aide ",
              "Expanded Value": "Doing well with a live in aide at home, per HPI ",
              "Page": 15
            },
            {
              "Impairment Category": "Cerebrovascular ",
              "Impairment": "IADLs ",
              "Feature": "IADL managing medications ",
              "Report Date": "09/27/2011 ",
              "Event Date": "",
              "Clinician Name": "Clark K ***, MD ",
              "Clinician Specialty": "General ",
              "Value": "needs assistance ",
              "Expanded Value": "Has been taking medications with his wife assistance, per HPI ",
              "Page": 57
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Exercise ",
              "Feature": "Exercise type ",
              "Report Date": "09/08/2011",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "dog walking ",
              "Expanded Value": "Has not been exercising except to walk the dog ",
              "Page": 19
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Exercise ",
              "Feature": "Frequency ",
              "Report Date": "09/08/2011",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "unspecified ",
              "Expanded Value": "Has not been exercising except to walk the dog ",
              "Page": 19
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "IADLs ",
              "Feature": "IADL driving or public transportation ",
              "Report Date": "09/08/2011",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "does not perform ",
              "Expanded Value": "No longer drives ",
              "Page": 19
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "IADLs ",
              "Feature": "IADL managing finances ",
              "Report Date": "09/08/2011",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "does not perform ",
              "Expanded Value": "He does not perform finances ",
              "Page": 19
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Sleep hygiene ",
              "Feature": "Sleep hygiene ",
              "Report Date": "09/08/2011",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "sleeps well ",
              "Expanded Value": "Sleeps well at night, per HPI ",
              "Page": 19
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Non- Compliance ",
              "Feature": "Non-Compliance ",
              "Report Date": "09/08/2011",
              "Event Date": "01/01/1900",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "declined minor recommendations ",
              "Expanded Value": "Did have OSA on sleep studies in past, but declined CPAP, per HPI ",
              "Page": 19
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Family involvement ",
              "Feature": "Family involvement in medical care ",
              "Report Date": "09/08/2011",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "attend visits ",
              "Expanded Value": "Accompanied today by his wife, per HPI ",
              "Page": 19
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Pets ",
              "Feature": "Pets ",
              "Report Date": "09/08/2011",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "Yes ",
              "Expanded Value": "Has not been exercising except to walk the dog ",
              "Page": 19
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Appearance ",
              "Feature": "Appearance ",
              "Report Date": "04/18/2011 ",
              "Event Date": "",
              "Clinician Name": "Carol A Wellons, NP ",
              "Clinician Specialty": "General ",
              "Value": "no acute distress ",
              "Expanded Value": "No acute distress, per physical exam ",
              "Page": 24
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Exercise ",
              "Feature": "Exercise type ",
              "Report Date": "11/05/2010",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Cardiac rehab ",
              "Expanded Value": "Has been exercising cardiac rehab with improvement in exercise tolerance, per HPI ",
              "Page": 115
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Exercise ",
              "Feature": "Frequency ",
              "Report Date": "11/05/2010",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "unspecified ",
              "Expanded Value": "Has been exercising cardiac rehab with improvement in exercise tolerance, per HPI ",
              "Page": 115
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Driving ability ",
              "Feature": "Driving ability ",
              "Report Date": "09/09/2010",
              "Event Date": "06/09/2010",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "not driving ",
              "Expanded Value": "Recently flunked his driving test, he is aware this and is not driving, per HPI ",
              "Page": 27
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Family involvement ",
              "Feature": "Family involvement in medical care ",
              "Report Date": "08/16/2010 ",
              "Event Date": "",
              "Clinician Name": "Dr *** ",
              "Clinician Specialty": "General ",
              "Value": "attend visits ",
              "Expanded Value": "His daughter was present for his history and physical ",
              "Page": 121
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Hospitalization ",
              "Feature": "Hospitalization duration ",
              "Report Date": "05/18/2010 ",
              "Event Date": "05/17/2010 ",
              "Clinician Name": "Clark ***, MD ",
              "Clinician Specialty": "General ",
              "Value": "2",
              "Expanded Value": "Admission date 05/17/2010, discharge date: 05/18/2010 ",
              "Page": 151
            },
            {
              "Impairment Category": "",
              "Impairment": "",
              "Feature": "",
              "Report Date": "",
              "Event Date": "",
              "Clinician Name": "",
              "Clinician Specialty": "",
              "Value": "Coronary artery ",
              "Expanded Value": "Coronary artery disease status post elective ",
              "Page": null
            },
            {
              "Impairment Category": "",
              "Impairment": "",
              "Feature": "",
              "Report Date": "",
              "Event Date": "",
              "Clinician Name": "",
              "Clinician Specialty": "",
              "Value": "disease status post elective percutaneous intervention and stenting of critically stenosed circumflex artery- ",
              "Expanded Value": "percutaneous intervention and stenting of critically stenosed circumflex artery- ",
              "Page": null
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Hospitalization ",
              "Feature": "Hospitalization reason ",
              "Report Date": "05/18/2010 ",
              "Event Date": "05/17/2010 ",
              "Clinician Name": "Clark ***, MD ",
              "Clinician Specialty": "General ",
              "Value": "underwent primary angioplasty and stenting of circumflex with placement of 3 mm X 23 mm, promus drug eluting stent. Recent anterior myocardial infarction with moderate LV dysfunction, hypertension and dyslipidemia ",
              "Expanded Value": "underwent primary angioplasty and stenting of circumflex with placement of 3 m3 X 23 mm, promus drug eluting stent. Recent anterior myocardial infarction with moderate LV dysfunction, hypertension and dyslipidemia ",
              "Page": 151
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "fatigue ",
              "Feature": "Fatigue ",
              "Report Date": "05/04/2010",
              "Event Date": "",
              "Clinician Name": "Unspecified ",
              "Clinician Specialty": "Unspecified ",
              "Value": "Acute ",
              "Expanded Value": "Fatigue, per assessment ",
              "Page": 126
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "sedentary ",
              "Feature": "Activity level ",
              "Report Date": "04/27/2010 ",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "sedentary ",
              "Expanded Value": "Sedentary activity level ",
              "Page": 35
            },
            {
              "Impairment Category": "Family History ",
              "Impairment": "Family history Longevity ",
              "Feature": "Family history of longevity-Father ",
              "Report Date": "04/27/2010 ",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "92",
              "Expanded Value": "Father died at 92, old age ",
              "Page": 35
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Immunization ",
              "Feature": "Immunization ",
              "Report Date": "04/27/2010 ",
              "Event Date": "10/01/2009",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "flu ",
              "Expanded Value": "Flu vaccine given in 10/01/2009 ",
              "Page": 36
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Hospitalization ",
              "Feature": "Hospitalization duration ",
              "Report Date": "04/13/2010 ",
              "Event Date": "04/10/2010",
              "Clinician Name": "Clark ***, MD ",
              "Clinician Specialty": "General ",
              "Value": "4",
              "Expanded Value": "Admitted on 04/10/2010 and discharged on 04/13/2010 ",
              "Page": 156
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Hospitalization ",
              "Feature": "Hospitalization reason ",
              "Report Date": "04/13/2010 ",
              "Event Date": "04/10/2010",
              "Clinician Name": "Clark ***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Admitted with chest pain and ST elevation consistent with an evolving anterior wall myocardial infarction ",
              "Expanded Value": "Admitted with chest pain and ST elevation consistent with an evolving anterior wall myocardial infarction per hospital course ",
              "Page": 156
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Appearance ",
              "Feature": "Appearance ",
              "Report Date": "04/10/2010",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "appears stated age ",
              "Expanded Value": "Appears stated age per physical examination ",
              "Page": 168
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Appearance ",
              "Feature": "Appearance ",
              "Report Date": "04/10/2010",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "no acute distress ",
              "Expanded Value": "No acute distress per physical examination ",
              "Page": 168
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Osteoarthritis ",
              "Feature": "Osteoarthritis ",
              "Report Date": "04/10/2010",
              "Event Date": "01/01/1900",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Yes ",
              "Expanded Value": "Osteoarthritis per PMH ",
              "Page": 167
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Pain ",
              "Feature": "Pain ",
              "Report Date": "04/10/2010",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Unspecified chest pain ",
              "Expanded Value": "Developed a left sided substernal chest pain radiating to the jaw associated with nausea, vomiting and diaphoresis lasting approximately 20 minutes, per HPI ",
              "Page": 167
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Employment ",
              "Feature": "Employment ",
              "Report Date": "09/10/2009",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Retired ",
              "Expanded Value": "Patient is in insurance sales, although is mostly retired, per SH ",
              "Page": 71
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Profession ",
              "Feature": "Profession ",
              "Report Date": "09/10/2009",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Insurance sales ",
              "Expanded Value": "Patient is in insurance sales, although is mostly retired, per SH ",
              "Page": 71
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "fatigue ",
              "Feature": "Fatigue ",
              "Report Date": "09/10/2009",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "fatigue ",
              "Expanded Value": "Has decreased energy, fatigue, per HPI ",
              "Page": 71
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Family involvement ",
              "Feature": "Family involvement in medical care ",
              "Report Date": "09/10/2009",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "attend visits ",
              "Expanded Value": "72 Year old right handed male presents with his daughter, Jennie Davis, who serves us the informant, per HPI ",
              "Page": 71
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Dizziness ",
              "Feature": "Dizziness/vertigo ",
              "Report Date": "07/30/2009 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Dizziness ",
              "Expanded Value": "Has dizziness, which is worse when is up, makes unsteady on feet, per reason for visit. ",
              "Page": 41
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "IADLs ",
              "Feature": "IADL driving or public transportation ",
              "Report Date": "06/18/2009 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "needs assistance ",
              "Expanded Value": "Sometimes needs direction when patient is out driving, per physical exam ",
              "Page": 44
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "alcohol-None ",
              "Feature": "Alcohol use ",
              "Report Date": "06/18/2009 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "none ",
              "Expanded Value": "There is no history of alcohol use, per SH ",
              "Page": 44
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Appearance ",
              "Feature": "Appearance ",
              "Report Date": "06/18/2009 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "no apparent distress ",
              "Expanded Value": "No apparent distress, per physical exam ",
              "Page": 45
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Appearance ",
              "Feature": "Appearance ",
              "Report Date": "06/18/2009 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "well-developed ",
              "Expanded Value": "Well developed, per physical exam ",
              "Page": 45
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Appearance ",
              "Feature": "Appearance ",
              "Report Date": "06/18/2009 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "well-nourished ",
              "Expanded Value": "Well nourished, per physical exam ",
              "Page": 45
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Sleep hygiene ",
              "Feature": "Sleep hygiene ",
              "Report Date": "06/18/2009 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "nocturia ",
              "Expanded Value": "Positive for nocturia, per ROS ",
              "Page": 45
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "non-smoker ",
              "Feature": "Smoking ",
              "Report Date": "06/18/2009 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "non-smoker ",
              "Expanded Value": "Patient is a non smoker, per SH ",
              "Page": 44
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Anxiety ",
              "Feature": "Anxiety ",
              "Report Date": "06/18/2009 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "no details ",
              "Expanded Value": "Notes some increase in anxiety, per reason for visit ",
              "Page": 44
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Depression ",
              "Feature": "Depression ",
              "Report Date": "06/18/2009 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "required anti- depressants only ",
              "Expanded Value": "Depression has been on Lexapro for about a month, per reason for visit ",
              "Page": 44
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Living status ",
              "Feature": "Living status ",
              "Report Date": "06/18/2009 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "living with spouse ",
              "Expanded Value": "Lives with wife per physical exam ",
              "Page": 44
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Bladder function ",
              "Feature": "Bladder function ",
              "Report Date": "06/18/2009 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "nocturia ",
              "Expanded Value": "Positive for nocturia, per ROS ",
              "Page": 45
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Hospitalization ",
              "Feature": "Hospitalization reason ",
              "Report Date": "06/18/2009 ",
              "Event Date": "01/01/2004",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Hospitalized five years ago for diverticulitis an had a poor recovery from anesthesia ",
              "Expanded Value": "Hospitalized five years ago for diverticulitis an had a poor recovery from anesthesia per physical exam. ",
              "Page": 44
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Spouse status ",
              "Feature": "Spouse status ",
              "Report Date": "06/18/2009 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Living ",
              "Expanded Value": "Lives with wife per physical exam ",
              "Page": 44
            }
           ],
        "Labs": [
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Albumin (Serum) ",
              "Value": "3.9",
              "Normal Range": "4.0-6.0 ",
              "Unit Of Measurement": "G/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 264
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Alkaline Phosphatase (ALP Or AP) ",
              "Value": "40",
              "Normal Range": "30-120 ",
              "Unit Of Measurement": "IU/L ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 264
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "ALT ",
              "Value": "19",
              "Normal Range": "0-35 ",
              "Unit Of Measurement": "IU/L ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 264
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "AST ",
              "Value": "27",
              "Normal Range": "0-35 ",
              "Unit Of Measurement": "IU/L ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 264
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Basophils (ABC) ",
              "Value": "0",
              "Normal Range": "0.0-0.2 ",
              "Unit Of Measurement": "Cells/ML ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Basophils% ",
              "Value": "0.5",
              "Normal Range": "0-1 ",
              "Unit Of Measurement": "% ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Bilirubin ",
              "Value": "0.9",
              "Normal Range": "0-1.0 ",
              "Unit Of Measurement": "Umol/L ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 264
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Blood Creatinine ",
              "Value": "1.15",
              "Normal Range": "0.5-1.3 ",
              "Unit Of Measurement": "Mg/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Blood Urea, Or Blood Urea Nitrogen (BUN) ",
              "Value": "15",
              "Normal Range": "7.0-25.0 ",
              "Unit Of Measurement": "Mg/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Calcium ",
              "Value": "9.4",
              "Normal Range": "8.6 10.2 ",
              "Unit Of Measurement": "Mg/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 264
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Carbon Dioxide ",
              "Value": "29",
              "Normal Range": "16-30 ",
              "Unit Of Measurement": "MEq/L ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Chloride ",
              "Value": "105",
              "Normal Range": "98-106 ",
              "Unit Of Measurement": "MEq/L ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "EGFR-NAA ",
              "Value": ">60 ",
              "Normal Range": ">60 ",
              "Unit Of Measurement": "ML/Min/1.73 M^2 ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 264
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Eosinophils (AEC) ",
              "Value": "0.3",
              "Normal Range": "0-350 ",
              "Unit Of Measurement": "Cells/UL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Eosinophils% ",
              "Value": "3.5",
              "Normal Range": "0-3 ",
              "Unit Of Measurement": "% ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Glucose ",
              "Value": "82",
              "Normal Range": "65-99 ",
              "Unit Of Measurement": "Mg/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hyperlipidemia ",
              "Feature Date": "05/29/2015 ",
              "Feature": "HDL ",
              "Value": "39",
              "Normal Range": "40-60 ",
              "Unit Of Measurement": "Mg/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
               "Result Evaluation": "Low ",
              "Page": 264
           },
            {
              "Impairment Category": "Blood Disorders ",
              "Impairment": "Anemia ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Hematocrit (HCT) ",
              "Value": "50.5",
              "Normal Range": "35.0- 45.0 ",
              "Unit Of Measurement": "% ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 262
           },
            {
              "Impairment Category": "Blood Disorders ",
              "Impairment": "Anemia ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Hemoglobin (HGB) ",
              "Value": "16.4",
              "Normal Range": "13.6- 17.0 ",
              "Unit Of Measurement": "G/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 262
           },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hyperlipidemia ",
              "Feature Date": "05/29/2015 ",
              "Feature": "LDL ",
              "Value": "34",
              "Normal Range": "65-100 ",
              "Unit Of Measurement": "Mg/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
               "Result Evaluation": "Low ",
              "Page": 264
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Lymphocytes (ALC) ",
              "Value": "2.5",
              "Normal Range": "1.2-5.5 ",
              "Unit Of Measurement": "Cells/ML ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Lymphocytes% ",
              "Value": "27.1",
              "Normal Range": "30-45 ",
              "Unit Of Measurement": "% ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "MCH ",
              "Value": "30.36",
              "Normal Range": "26.0- 32.0 ",
              "Unit Of Measurement": "Pg ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "MCHC ",
              "Value": "32.4",
              "Normal Range": "32.0- 36.0 ",
              "Unit Of Measurement": "G/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Blood Disorders ",
              "Impairment": "Anemia ",
              "Feature Date": "05/29/2015 ",
              "Feature": "MCV ",
              "Value": "93.5",
              "Normal Range": "80.0- 94.0 ",
              "Unit Of Measurement": "FL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Monocytes (AMC) ",
              "Value": "0.6",
              "Normal Range": "0-6.6 ",
              "Unit Of Measurement": "Cells/ML ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Monocytes% ",
              "Value": "6.3",
              "Normal Range": "0-6 ",
              "Unit Of Measurement": "% ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "MPV ",
              "Value": "11.5",
              "Normal Range": "7.4-10.4 ",
              "Unit Of Measurement": "FL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
 "Result Evaluation": "High",              "Page": 263
           },
            {
              "Impairment Category": "Blood Disorders ",
              "Impairment": "Anemia ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Neutrophils (ANC) ",
              "Value": "5.9",
              "Normal Range": "2.0-7.7 ",
              "Unit Of Measurement": "Cells/ML ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Blood Disorders ",
              "Impairment": "Anemia ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Neutrophils% ",
              "Value": "62.6",
              "Normal Range": "50-70 ",
              "Unit Of Measurement": "% ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Platelet Count ",
              "Value": "146",
              "Normal Range": "150-450 ",
              "Unit Of Measurement": "10*3/UL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Potassium ",
              "Value": "4.2",
              "Normal Range": "3.5-5.0 ",
              "Unit Of Measurement": "MEq/L ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Blood Disorders ",
              "Impairment": "Anemia ",
              "Feature Date": "05/29/2015 ",
              "Feature": "RBC ",
              "Value": "5.4",
              "Normal Range": "4.5-5.7 ",
              "Unit Of Measurement": "10*6/UL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 262
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "RDW ",
              "Value": "13.7",
              "Normal Range": "11.5- 14.5 ",
              "Unit Of Measurement": "% ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Sodium ",
              "Value": "139",
              "Normal Range": "136-145 ",
              "Unit Of Measurement": "Mmol/L ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 263
           },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hyperlipidemia ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Total Cholesterol ",
              "Value": "98",
              "Normal Range": "140-199 ",
              "Unit Of Measurement": "Mg/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
               "Result Evaluation": "Low ",
              "Page": 264
           },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hyperlipidemia ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Total Cholesterol/HDL-C Ratio ",
              "Value": "2.5",
              "Normal Range": "<5.0 ",
              "Unit Of Measurement": "N/A ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 264
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Total Protein ",
              "Value": "6.6",
              "Normal Range": "6.0-8.0 ",
              "Unit Of Measurement": "G/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 264
           },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hyperlipidemia ",
              "Feature Date": "05/29/2015 ",
              "Feature": "Triglycerides ",
              "Value": "123",
              "Normal Range": "0-150 ",
              "Unit Of Measurement": "Mg/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 264
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "N/A ",
              "Feature Date": "05/29/2015 ",
              "Feature": "TSH ",
              "Value": "0.44",
              "Normal Range": "0.5-4.5 ",
              "Unit Of Measurement": "MIU/L ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 264
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "05/29/2015 ",
              "Feature": "WBC Count ",
              "Value": "9.4",
              "Normal Range": "4.5-11.0 ",
              "Unit Of Measurement": "10*3/UL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 262
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "03/17/2014 ",
              "Feature": "A/G Ratio ",
              "Value": "2",
              "Normal Range": "0.8-2.0 ",
              "Unit Of Measurement": "N/A ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 260
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CMP Panel ",
              "Feature Date": "03/17/2014 ",
              "Feature": "Glucose ",
              "Value": "119",
              "Normal Range": "65-99 ",
              "Unit Of Measurement": "Mg/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
 "Result Evaluation": "High",
               "Page": 287
           },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hyperlipidemia ",
              "Feature Date": "03/17/2014 ",
              "Feature": "HDL ",
              "Value": "32",
              "Normal Range": ">=40 ",
              "Unit Of Measurement": "Mg/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
               "Result Evaluation": "Low ",
              "Page": 288
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "03/17/2014 ",
              "Feature": "Platelet Count ",
              "Value": "136",
              "Normal Range": "140-400 ",
              "Unit Of Measurement": "10*3/UL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
               "Result Evaluation": "Low ",
              "Page": 287
           },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hyperlipidemia ",
              "Feature Date": "03/17/2014 ",
              "Feature": "Total Cholesterol ",
              "Value": "106",
              "Normal Range": "125-200 ",
              "Unit Of Measurement": "Mg/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
               "Result Evaluation": "Low ",
              "Page": 288
           },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hyperlipidemia ",
              "Feature Date": "03/17/2014 ",
              "Feature": "Triglycerides ",
              "Value": "325",
              "Normal Range": "<150 ",
              "Unit Of Measurement": "Mg/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
 "Result Evaluation": "High",              "Page": 288
           },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hyperlipidemia ",
              "Feature Date": "09/28/2012 ",
              "Feature": "HDL ",
              "Value": "36",
              "Normal Range": ">=40 ",
              "Unit Of Measurement": "Mg/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
               "Result Evaluation": "Low ",
              "Page": 7
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "CBC Panel ",
              "Feature Date": "09/28/2012 ",
              "Feature": "Platelet Count ",
              "Value": "123",
              "Normal Range": "140-400 ",
              "Unit Of Measurement": "10*3/UL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
               "Result Evaluation": "Low ",
              "Page": 6
           },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hyperlipidemia ",
              "Feature Date": "09/28/2012 ",
              "Feature": "Total Cholesterol ",
              "Value": "98",
              "Normal Range": "125-200 ",
              "Unit Of Measurement": "Mg/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
               "Result Evaluation": "Low ",
              "Page": 7
           },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hyperlipidemia ",
              "Feature Date": "09/28/2012 ",
              "Feature": "Triglycerides ",
              "Value": "152",
              "Normal Range": "<150 ",
              "Unit Of Measurement": "Mg/DL ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
 "Result Evaluation": "High",              "Page": 7
           },
            {
              "Impairment Category": "Labs ",
              "Impairment": "N/A ",
              "Feature Date": "09/28/2012 ",
              "Feature": "Vitamin B12 ",
              "Value": "585",
              "Normal Range": "190-950 ",
              "Unit Of Measurement": "Pg/ML ",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "Unspecified ",
              "Result Evaluation":  "Normal",
              "Page": 6
           }
           ],
        "Test": [
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "05/29/2015 ",
              "Event Feature Date": "Blood pressure ",
              "Value": "120/80 ",
              "Expanded Value": "Blood pressure 120/80 ",
              "Page": "244"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "05/29/2015 ",
              "Event Feature Date": "Blood pressure ",
              "Value": "156/86 ",
              "Expanded Value": "Blood pressure 156/86 ",
              "Page": "244"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "BMI ",
              "Report Date": "05/29/2015 ",
              "Event Feature Date": "BMI ",
              "Value": "29.37",
              "Expanded Value": "BMI 29.37 ",
              "Page": "244"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "Height ",
              "Report Date": "05/29/2015 ",
              "Event Feature Date": "Height ",
              "Value": "69",
              "Expanded Value": "Height 5'9\" ",
              "Page": "244"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "05/29/2015 ",
              "Event Feature Date": "Hypertension diagnosed ",
              "Value": "Yes ",
              "Expanded Value": "Unspecified essential hypertension, controlled ",
              "Page": "241"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Report Date": "05/29/2015 ",
              "Event Feature Date": "Orientation to person ",
              "Value": "No ",
              "Expanded Value": "Not oriented to person, per physical exam ",
              "Page": "245"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Report Date": "05/29/2015 ",
              "Event Feature Date": "Orientation to place ",
              "Value": "No ",
              "Expanded Value": "Not oriented to place, per physical exam ",
              "Page": "245"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Report Date": "05/29/2015 ",
              "Event Feature Date": "Orientation to situation ",
              "Value": "No ",
              "Expanded Value": "Not oriented to situation, per physical exam ",
              "Page": "245"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Report Date": "05/29/2015 ",
              "Event Feature Date": "Orientation to time ",
              "Value": "Yes ",
              "Expanded Value": "Not oriented to time, per physical exam ",
              "Page": "245"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "N/A ",
              "Report Date": "05/29/2015 ",
              "Event Feature Date": "Pulse ",
              "Value": "70",
              "Expanded Value": "Pulse 70 ",
              "Page": "244"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "Weight ",
              "Report Date": "05/29/2015 ",
              "Event Feature Date": "Weight ",
              "Value": "198.9",
              "Expanded Value": "Weight 198.9 ",
              "Page": "244"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "05/12/2015",
              "Event Feature Date": "Blood pressure ",
              "Value": "130/72 ",
              "Expanded Value": "Blood pressure 130/72 ",
              "Page": "221"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Report Date": "05/12/2015",
              "Event Feature Date": "Orientation to person ",
              "Value": "Yes ",
              "Expanded Value": "Oriented to person, per physical exam ",
              "Page": "221"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Report Date": "05/12/2015",
              "Event Feature Date": "Orientation to place ",
              "Value": "Yes ",
              "Expanded Value": "Oriented to place, per physical exam ",
              "Page": "221"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Report Date": "05/12/2015",
              "Event Feature Date": "Orientation to time ",
              "Value": "Yes ",
              "Expanded Value": "Oriented to time, per physical exam ",
              "Page": "221"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "11/07/2014",
              "Event Feature Date": "Blood pressure ",
              "Value": "130/70 ",
              "Expanded Value": "Blood pressure 130/70 ",
              "Page": "234"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "BMI ",
              "Report Date": "11/07/2014",
              "Event Feature Date": "BMI ",
              "Value": "29.82",
              "Expanded Value": "BMI 29.82 ",
              "Page": "234"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "Height ",
              "Report Date": "11/07/2014",
              "Event Feature Date": "Height ",
              "Value": "69.5",
              "Expanded Value": "Height 5'9.5\" ",
              "Page": "234"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "N/A ",
              "Report Date": "11/07/2014",
              "Event Feature Date": "Pulse ",
              "Value": "70",
              "Expanded Value": "Pulse 70 ",
              "Page": "234"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "Weight ",
              "Report Date": "11/07/2014",
              "Event Feature Date": "Weight ",
              "Value": "204",
              "Expanded Value": "Weight 204 ",
              "Page": "234"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "04/25/2014 ",
              "Event Feature Date": "Blood pressure ",
              "Value": "140/78 ",
              "Expanded Value": "Blood pressure 140/78 ",
              "Page": "231"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "03/17/2014 ",
              "Event Feature Date": "Blood pressure ",
              "Value": "130/70 ",
              "Expanded Value": "Blood pressure 130/70 ",
              "Page": "253"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "10/18/2013 ",
              "Event Feature Date": "Blood pressure ",
              "Value": "122/70 ",
              "Expanded Value": "Blood pressure 122/70 ",
              "Page": "228"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "BMI ",
              "Report Date": "10/18/2013 ",
              "Event Feature Date": "BMI ",
              "Value": "29.55",
              "Expanded Value": "BMI 29.55 ",
              "Page": "228"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "Height ",
              "Report Date": "10/18/2013 ",
              "Event Feature Date": "Height ",
              "Value": "69.25",
              "Expanded Value": "Height 5'9.25\" ",
              "Page": "228"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "N/A ",
              "Report Date": "10/18/2013 ",
              "Event Feature Date": "Pulse ",
              "Value": "75",
              "Expanded Value": "Pulse 75 ",
              "Page": "228"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "Weight ",
              "Report Date": "10/18/2013 ",
              "Event Feature Date": "Weight ",
              "Value": "201",
              "Expanded Value": "Weight 201 ",
              "Page": "228"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "04/09/2013",
              "Event Feature Date": "Blood pressure ",
              "Value": "130/76 ",
              "Expanded Value": "Blood pressure 130/76 ",
              "Page": "77"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "03/25/2013 ",
              "Event Feature Date": "Blood pressure ",
              "Value": "120/70 ",
              "Expanded Value": "Blood pressure 120/70 ",
              "Page": "3"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "03/25/2013 ",
              "Event Feature Date": "Blood pressure ",
              "Value": "124/86 ",
              "Expanded Value": "Blood pressure 124/86 ",
              "Page": "3"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "BMI ",
              "Report Date": "03/25/2013 ",
              "Event Feature Date": "BMI ",
              "Value": "30.12",
              "Expanded Value": "BMI 30.12 ",
              "Page": "3"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "Height ",
              "Report Date": "03/25/2013 ",
              "Event Feature Date": "Height ",
              "Value": "69",
              "Expanded Value": "Height 5'9\" ",
              "Page": "3"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "N/A ",
              "Report Date": "03/25/2013 ",
              "Event Feature Date": "Pulse ",
              "Value": "60",
              "Expanded Value": "Pulse 60 ",
              "Page": "3"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "Weight ",
              "Report Date": "03/25/2013 ",
              "Event Feature Date": "Weight ",
              "Value": "204",
              "Expanded Value": "Weight 204 ",
              "Page": "3"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "09/28/2012 ",
              "Event Feature Date": "Blood pressure ",
              "Value": "105/70 ",
              "Expanded Value": "Blood pressure 105/70 ",
              "Page": "11"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "09/28/2012 ",
              "Event Feature Date": "Blood pressure ",
              "Value": "106/80 ",
              "Expanded Value": "Blood pressure 106/80 ",
              "Page": "11"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "BMI ",
              "Report Date": "09/28/2012 ",
              "Event Feature Date": "BMI ",
              "Value": "29.68",
              "Expanded Value": "BMI 29.68 ",
              "Page": "11"
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Temperature ",
              "Report Date": "09/28/2012 ",
              "Event Feature Date": "Body temperature ",
              "Value": "98.3",
              "Expanded Value": "Temperature 98.3 ",
              "Page": "11"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "Height ",
              "Report Date": "09/28/2012 ",
              "Event Feature Date": "Height ",
              "Value": "69",
              "Expanded Value": "Height 5'9\" ",
              "Page": "11"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "Weight ",
              "Report Date": "09/28/2012 ",
              "Event Feature Date": "Weight ",
              "Value": "201",
              "Expanded Value": "Weight 201 ",
              "Page": "11"
            },
            {
              "Impairment Category": "Valvular heart disease ",
              "Impairment": "N/A ",
              "Report Date": "03/27/2012 ",
              "Event Feature Date": "Bicuspid vs trileaflet valve ",
              "Value": "trileaflet ",
              "Expanded Value": "Aortic valve-trileaflet ",
              "Page": "113"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "03/27/2012 ",
              "Event Feature Date": "Blood pressure ",
              "Value": "130/70 ",
              "Expanded Value": "Blood pressure 130/70 ",
              "Page": "55"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "heart failure ",
              "Report Date": "03/27/2012 ",
              "Event Feature Date": "Echocardiogram Ejection Fraction/LVEF/ EF ",
              "Value": "25-35 ",
              "Expanded Value": "Estimated ejection fraction was in range of 25-35% ",
              "Page": "113"
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "03/27/2012 ",
              "Event Feature Date": "Echocardiogram - Impression ",
              "Value": "Akinesis ",
              "Expanded Value": "There was large area of apical akinesis with associated apparent 2.5 cm filling defect ",
              "Page": "113"
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "03/27/2012 ",
              "Event Feature Date": "Echocardiogram - Impression ",
              "Value": "hypokinesis ",
              "Expanded Value": "Hypokinesis is most apparent in mid to apical anteroseptal wall and ",
              "Page": "113"
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "03/27/2012 ",
              "Event Feature Date": "Echocardiogram Impression ",
              "Value": "dilated L atrium ",
              "Expanded Value": "Left atrium was mildly dilated ",
              "Page": "113"
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "03/27/2012 ",
              "Event Feature Date": "Echocardiogram Impression ",
              "Value": "Left ventricular hypertrophy ",
              "Expanded Value": "Mild to moderate LVH ",
              "Page": "113"
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "03/27/2012 ",
              "Event Feature Date": "Echocardiogram - Impression ",
              "Value": "normal findings ",
              "Expanded Value": "Left ventricular cavity size was normal. Structurally normal aortic/pulmonic/tricuspid valve. RV Cavity size and systolic function normal. Right atrium normal in size, inferior vena cava normal in size ",
              "Page": "112- 113 "
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "03/27/2012 ",
              "Event Feature Date": "Echocardiogram Left Ventricle / LVDD (diastolic diameter ",
              "Value": "54",
              "Expanded Value": "LVDD is 54 mm ",
              "Page": "113"
            },
            {
              "Impairment Category": "Valvular heart disease ",
              "Impairment": "N/A ",
              "Report Date": "03/27/2012 ",
              "Event Feature Date": "Echocardiogram Regurgitation ",
              "Value": "Aortic ",
              "Expanded Value": "Mild aortic valve regurgitation ",
              "Page": "113"
            },
            {
              "Impairment Category": "Valvular heart disease ",
              "Impairment": "N/A ",
              "Report Date": "03/27/2012 ",
              "Event Feature Date": "Echocardiogram Regurgitation ",
              "Value": "mitral ",
              "Expanded Value": "Mild mitral valve regurgitation ",
              "Page": "113"
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "03/27/2012 ",
              "Event Feature Date": "Echocardiogram Type ",
              "Value": "Transthoracic ",
              "Expanded Value": "Transthoracic echo ",
              "Page": "112"
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "03/27/2012 ",
              "Event Feature Date": "Echocardiogram - Type ",
              "Value": "2D echo ",
              "Expanded Value": "2D echo ",
              "Page": "112"
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "03/27/2012 ",
              "Event Feature Date": "Echocardiogram - Type ",
              "Value": "doppler ",
              "Expanded Value": "Doppler echo ",
              "Page": "112"
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "03/27/2012 ",
              "Event Feature Date": "Mean Gradient ",
              "Value": "2",
              "Expanded Value": "Mean gradient: 2 mmHg ",
              "Page": "113"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "03/05/2012",
              "Event Feature Date": "Blood pressure ",
              "Value": "130/70 ",
              "Expanded Value": "Blood pressure 130/70 ",
              "Page": "17"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "03/05/2012",
              "Event Feature Date": "Blood pressure ",
              "Value": "110/70 ",
              "Expanded Value": "Blood pressure 110/70 ",
              "Page": "17"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "09/08/2011",
              "Event Feature Date": "Blood pressure ",
              "Value": "130/80 ",
              "Expanded Value": "Blood pressure 130/80 ",
              "Page": "21"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Hypertension ",
              "Report Date": "09/08/2011",
              "Event Feature Date": "Blood pressure ",
              "Value": "120/70 ",
              "Expanded Value": "Blood pressure 120/70 ",
              "Page": "21"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "BMI ",
              "Report Date": "09/08/2011",
              "Event Feature Date": "BMI ",
              "Value": "31.3",
              "Expanded Value": "BMI 31.3 ",
              "Page": "21"
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Temperature ",
              "Report Date": "09/08/2011",
              "Event Feature Date": "Body temperature ",
              "Value": "97",
              "Expanded Value": "Temperature 97 ",
              "Page": "21"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "Height ",
              "Report Date": "09/08/2011",
              "Event Feature Date": "Height ",
              "Value": "69",
              "Expanded Value": "Height 5'9\" ",
              "Page": "21"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "N/A ",
              "Report Date": "09/08/2011",
              "Event Feature Date": "Pulse ",
              "Value": "72",
              "Expanded Value": "Pulse 72 ",
              "Page": "21"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "Weight ",
              "Report Date": "09/08/2011",
              "Event Feature Date": "Weight ",
              "Value": "212",
              "Expanded Value": "Weight 212 ",
              "Page": "21"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "N/A ",
              "Report Date": "12/09/2010",
              "Event Feature Date": "CXR Findings ",
              "Value": "no disease ",
              "Expanded Value": "No active disease. Lungs are clear and there is no infiltrate, effusion or pneumothorax. Heart and mediastinal silhouette are normal ",
              "Page": "118"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "N/A ",
              "Report Date": "12/09/2010",
              "Event Feature Date": "CXR Findings ",
              "Value": "past surgery ",
              "Expanded Value": "Examination of chest shows pacing device in good position ",
              "Page": "118"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "Height ",
              "Report Date": "11/05/2010",
              "Event Feature Date": "Height ",
              "Value": "68",
              "Expanded Value": "Height 68 ",
              "Page": "117"
            },
            {
              "Impairment Category": "Basic ",
              "Impairment": "Weight ",
              "Report Date": "11/05/2010",
              "Event Feature Date": "Weight ",
              "Value": "206",
              "Expanded Value": "Weight 206 ",
              "Page": "117"
            },
            {
              "Impairment Category": "Lifestyle ",
              "Impairment": "Temperature ",
              "Report Date": "09/09/2010",
              "Event Feature Date": "Body temperature ",
              "Value": "97.8",
              "Expanded Value": "Temperature 97.8 ",
              "Page": "29"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "N/A ",
              "Report Date": "09/09/2010",
              "Event Feature Date": "Pulse ",
              "Value": "72",
              "Expanded Value": "Pulse 72 ",
              "Page": "29"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "heart failure ",
              "Report Date": "07/20/2010 ",
              "Event Feature Date": "Echocardiogram Diastolic Dysfunction ",
              "Value": "present ",
              "Expanded Value": "LV diastolic dysfunction present ",
              "Page": "144"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "heart failure ",
              "Report Date": "07/20/2010 ",
              "Event Feature Date": "Echocardiogram - Ejection Fraction / LVEF / EF ",
              "Value": "30-35 ",
              "Expanded Value": "Estimated ejection fraction 30-35% ",
              "Page": "144"
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "07/20/2010 ",
              "Event Feature Date": "Echocardiogram - Impression ",
              "Value": "normal findings ",
              "Expanded Value": "Normal RA/RV size, RV systolic function, inferior/posterior wall motion. Normal mitral/tricuspid/pulmonic valve. Normal aortic arch, pulmonary artery, inferior vena cava and pericardium, no pericardium effusion ",
              "Page": "144"
            },
            {
              "Impairment Category": "Valvular heart disease ",
              "Impairment": "N/A ",
              "Report Date": "07/20/2010 ",
              "Event Feature Date": "Echocardiogram - Impression ",
              "Value": "sclerosis ",
              "Expanded Value": "Mildly aortic sclerotic ",
              "Page": "144"
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "07/20/2010 ",
              "Event Feature Date": "Echocardiogram - Impression ",
              "Value": "hypokinesis ",
              "Expanded Value": "Moderate to severe left ventricular dysfunction with anteroseptal and distal lateral hypokinesis and apical ",
              "Page": "144"
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "07/20/2010 ",
              "Event Feature Date": "Echocardiogram Impression ",
              "Value": "N/A ",
              "Expanded Value": "LV size moderately enlarged ",
              "Page": "144"
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "07/20/2010 ",
              "Event Feature Date": "Echocardiogram Impression ",
              "Value": "Akinesis ",
              "Expanded Value": "Apical wall akinesis ",
              "Page": "144"
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "07/20/2010 ",
              "Event Feature Date": "Echocardiogram Left Ventricle / LVDD (diastolic diameter ",
              "Value": "53",
              "Expanded Value": "LVDD is 5.3 cm ",
              "Page": "144"
            },
            {
              "Impairment Category": "Valvular heart disease ",
              "Impairment": "N/A ",
              "Report Date": "07/20/2010 ",
              "Event Feature Date": "Echocardiogram Regurgitation ",
              "Value": "Aortic ",
              "Expanded Value": "mild aortic regurgitation ",
              "Page": "144"
            },
            {
              "Impairment Category": "Valvular heart disease ",
              "Impairment": "N/A ",
              "Report Date": "07/20/2010 ",
              "Event Feature Date": "Echocardiogram - Regurgitation ",
              "Value": "mitral ",
              "Expanded Value": "mild mitral regurgitation ",
              "Page": "144"
            },
            {
              "Impairment Category": "Valvular heart disease ",
              "Impairment": "N/A ",
              "Report Date": "07/20/2010 ",
              "Event Feature Date": "Echocardiogram - Regurgitation ",
              "Value": "tricuspid ",
              "Expanded Value": "mild tricuspid regurgitation ",
              "Page": "144"
            },
            {
              "Impairment Category": "Valvular heart disease ",
              "Impairment": "N/A ",
              "Report Date": "07/20/2010 ",
              "Event Feature Date": "Echocardiogram - Regurgitation ",
              "Value": "pulmonic ",
              "Expanded Value": "Trace pulmonic regurgitation ",
              "Page": "144"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "N/A ",
              "Report Date": "07/20/2010 ",
              "Event Feature Date": "Echocardiogram - Right Ventricle Systolic Pressure/RVSP ",
              "Value": "36",
              "Expanded Value": "RVSP 36 mmHg ",
              "Page": "144"
            },
            {
              "Impairment Category": "N/A ",
              "Impairment": "N/A ",
              "Report Date": "07/20/2010 ",
              "Event Feature Date": "Echocardiogram Type ",
              "Value": "doppler ",
              "Expanded Value": "Doppler and color flow ",
              "Page": "144"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "05/17/2010 ",
              "Event Feature Date": "Cardiac catheterization - Complications ",
              "Value": "None ",
              "Expanded Value": "No complications occurred ",
              "Page": "153"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "05/17/2010 ",
              "Event Feature Date": "Cardiac catheterization - Findings ",
              "Value": "Location and severity and/or % of blockage stated ",
              "Expanded Value": "Mid circumflex: 90% stenosis, there was T1M1 grade 3 flow through the vessel ",
              "Page": "153"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "05/17/2010 ",
              "Event Feature Date": "Cardiac catheterization - Indication ",
              "Value": "angina ",
              "Expanded Value": "Angina/MI: class II ",
              "Page": "153"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "05/17/2010 ",
              "Event Feature Date": "Cardiac catheterization - Indication ",
              "Value": "CAD ",
              "Expanded Value": "Coronary artery disease: ischemic heart disease (critical Cx lesion) ",
              "Page": "153"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "05/17/2010 ",
              "Event Feature Date": "Cardiac catheterization - Procedure ",
              "Value": "stents placed ",
              "Expanded Value": "Performed drug eluting stent, intervention on mid circumflex stent ",
              "Page": "153"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "05/17/2010 ",
              "Event Feature Date": "Cardiac catheterization Procedure ",
              "Value": "right heart cath ",
              "Expanded Value": "Performed iliac cath placement w/cc right ",
              "Page": "153"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/12/2010",
              "Event Feature Date": "EKG Heart rate ",
              "Value": "78",
              "Expanded Value": "Heart rate 78 bpm ",
              "Page": "158"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/12/2010",
              "Event Feature Date": "EKG Infarction ",
              "Value": "Inferior ",
              "Expanded Value": "Possible inferior infarct-age undetermined ",
              "Page": "158"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/12/2010",
              "Event Feature Date": "EKG Infarction ",
              "Value": "Age undetermined ",
              "Expanded Value": "Possible inferior infarct-age undetermined ",
              "Page": "158"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/12/2010",
              "Event Feature Date": "EKG Infarction ",
              "Value": "Present ",
              "Expanded Value": "Anterolateral infarct-evolving. ",
              "Page": "158"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/12/2010",
              "Event Feature Date": "EKG Infarction ",
              "Value": "possible ",
              "Expanded Value": "Possible inferior infarct-age undetermined ",
              "Page": "158"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/12/2010",
              "Event Feature Date": "EKG Overall ",
              "Value": "abnormal ",
              "Expanded Value": "Anterolateral infarct-evolving. Abnormal EKG. Compared to prior EKG PVCs not seen ",
              "Page": "158"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/12/2010",
              "Event Feature Date": "EKG Rhythm ",
              "Value": "Sinus rhythm ",
              "Expanded Value": "Sinus rhythm ",
              "Page": "158"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "Cardiac catheterization Ejection fraction ",
              "Value": "35-40 ",
              "Expanded Value": "Moderate left ventricular systolic dysfunction with estimated ejection fraction of 35-40% ",
              "Page": "163"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "Cardiac catheterization - Findings ",
              "Value": "Hypokinesis ",
              "Expanded Value": "Anterolateral and apical hypokinesis ",
              "Page": "163"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "Cardiac catheterization Findings ",
              "Value": "N/A ",
              "Expanded Value": "Marked elevation of left ventricular end-diastolic pressure ",
              "Page": "163"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "Cardiac catheterization Findings ",
              "Value": "occlusion ",
              "Expanded Value": "Complete occlusion of proximal to mid left anterior descending as with no antegrade flow ",
              "Page": "163"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "Cardiac catheterization - Findings ",
              "Value": "plaque ",
              "Expanded Value": "Significant disease in marginal branch of circumflex and angiographic plaquing diffusely ",
              "Page": "163"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "Cardiac catheterization - Findings ",
              "Value": "calcification ",
              "Expanded Value": "Left main has mild diffuse calcification ",
              "Page": "162"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "Cardiac catheterization - Findings ",
              "Value": "Location and severity and/or % of blockage stated ",
              "Expanded Value": "in proximal to mid portioFirst diagonal branch seemed to be filling, has an ostial 70% stenosis followed by second 90% stenosis in mid portion above terminal bifurcation. Circumflex: Gives rise to ramus branch has 50 to 60% stenosis in mid portion, first marginal branch has high grade 70-80% lesion. RCA: 20% stenosis noted at catheter tip proximally, distally there is 30% stenosis at origin of posterior descending branch ",
              "Page": "162- 163 "
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "Cardiac catheterization Indication ",
              "Value": "MI ",
              "Expanded Value": "Was asked to see on emergency room in setting of evolving anterior wall myocardial infarction ",
              "Page": "162"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "Cardiac catheterization Negative results ",
              "Value": "normal ventricular function ",
              "Expanded Value": "left ventricular systolic pressure was within normal limits, LVED pressure was 35-40 mmHg ",
              "Page": "162"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "Cardiac catheterization Overall ",
              "Value": "N/A ",
              "Expanded Value": "Mild to moderate LV enlargement ",
              "Page": "163"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "Cardiac catheterization - Overall ",
              "Value": "normal ",
              "Expanded Value": "Aortic root normal appearance. no significant mitral regurgitation notes, no high grade disease. ",
              "Page": "163"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "Cardiac catheterization - Procedure ",
              "Value": "coronary angiography/angiogram/arteriogram ",
              "Expanded Value": "Performed coronary arteriography ",
              "Page": "162"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "EKG Arrhythmias ",
              "Value": "PVCs ",
              "Expanded Value": "Sinus rhythm with frequent multifocal PVCs ",
              "Page": "160"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "EKG Heart rate ",
              "Value": "84",
              "Expanded Value": "Heart rate 84 bpm ",
              "Page": "160"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "EKG Infarction ",
              "Value": "Inferior ",
              "Expanded Value": "Possible inferior infarct-age undetermined ",
              "Page": "160"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "EKG Infarction ",
              "Value": "Age undetermined ",
              "Expanded Value": "Possible inferior infarct-age undetermined ",
              "Page": "160"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "EKG Infarction ",
              "Value": "possible ",
              "Expanded Value": "Possible inferior infarct-age undetermined ",
              "Page": "160"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "EKG Overall ",
              "Value": "abnormal ",
              "Expanded Value": "Anteroseptal ST elevation, consider acute infarct. Abnormal EKG ",
              "Page": "160"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Report Date": "04/10/2010",
              "Event Feature Date": "EKG Rhythm ",
              "Value": "Sinus rhythm ",
              "Expanded Value": "Sinus rhythm ",
              "Page": "160"
            }
           ],
        "Impairments":[
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Atheroclerosis ",
              "Feature": "Disease present ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Heart ",
              "Expanded Value": "Coronary atherosclerosis of unspecified type of vessel, native or graft-stable ",
              "Page": "241"
            },
            {
              "Impairment Category": "Gastrointestinal ",
              "Impairment": "GERD ",
              "Feature": "Gastrointestinal disorders ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "GERD ",
              "Expanded Value": "Esophageal reflux- controlled ",
              "Page": "241"
            },
            {
              "Impairment Category": "Gastrointestinal ",
              "Impairment": "diverticulitis ",
              "Feature": "Gastrointestinal disorders ",
              "Report Date": "05/29/2015 ",
              "Event Date": "01/01/2004",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "diverticulitis ",
              "Expanded Value": "Diverticulitis in 2004, per PMH ",
              "Page": "242"
            },
            {
              "Impairment Category": "No Match ",
              "Impairment": "MI ",
              "Feature": "In medical history only ",
              "Report Date": "05/29/2015 ",
              "Event Date": "01/01/2010",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "> 1 mention ",
              "Expanded Value": "Myocardial infarction in 2010 ",
              "Page": "242"
            },
            {
              "Impairment Category": "No Match ",
              "Impairment": "CAD ",
              "Feature": "In medical history only ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "> 1 mention ",
              "Expanded Value": "Coronary atherosclerosis of unspecified type of vessel, native or graft-stable ",
              "Page": "241"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Feature": "Cognitive impairment manifestations ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Memory issues ",
              "Expanded Value": "Impaired recent memory, per physical exam ",
              "Page": "245"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Feature": "Dementia Type ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Alzheimer's ",
              "Expanded Value": "Alzheimer's disease, stable, per HPI ",
              "Page": "241"
            },
            {
              "Impairment Category": "Pulmonary ",
              "Impairment": "chronic bronchitis ",
              "Feature": "Type of pulmonary disease ",
              "Report Date": "05/29/2015 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Bronchitis ",
              "Expanded Value": "Bronchitis, per HPI ",
              "Page": "242"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Feature": "# Stents Placed ",
              "Report Date": "05/12/2015",
              "Event Date": "01/01/1900",
              "Clinician Name": "Clark McKenzia, MD ",
              "Clinician Specialty": "General ",
              "Value": "unspecified ",
              "Expanded Value": "CAD with previous anterior MI-LAD/Cx stenting, per assessment ",
              "Page": "222"
            },
            {
              "Impairment Category": "No Match ",
              "Impairment": "CAD ",
              "Feature": "In medical history only ",
              "Report Date": "05/12/2015",
              "Event Date": "",
              "Clinician Name": "Clark McKenzia, MD ",
              "Clinician Specialty": "General ",
              "Value": "> 1 mention ",
              "Expanded Value": "CAD with previous anterior MI-LAD/Cx stenting, per assessment ",
              "Page": "222"
            },
            {
              "Impairment Category": "No Match ",
              "Impairment": "Dementia ",
              "Feature": "In medical history only ",
              "Report Date": "05/12/2015",
              "Event Date": "01/01/1900",
              "Clinician Name": "Clark McKenzia, MD ",
              "Clinician Specialty": "General ",
              "Value": "> 1 mention ",
              "Expanded Value": "Dementia, per problem list ",
              "Page": "220"
            },
            {
              "Impairment Category": "No Match ",
              "Impairment": "Cardiomyopathy ",
              "Feature": "In medical history only ",
              "Report Date": "05/12/2015",
              "Event Date": "07/15/2013 ",
              "Clinician Name": "Clark McKenzia, MD ",
              "Clinician Specialty": "General ",
              "Value": "> 1 mention ",
              "Expanded Value": "Other primary cardiomyopathies on 07/15/2013 ",
              "Page": "219"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "MI ",
              "Feature": "Type of heart attack ",
              "Report Date": "05/12/2015",
              "Event Date": "04/01/2010",
              "Clinician Name": "Clark McKenzia, MD ",
              "Clinician Specialty": "General ",
              "Value": "anterior ",
              "Expanded Value": "Anterior MI on 04/2010, per problem list ",
              "Page": "219"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "heart failure ",
              "Feature": "NYHA Class ",
              "Report Date": "05/12/2015",
              "Event Date": "01/01/1900",
              "Clinician Name": "Clark McKenzia, MD ",
              "Clinician Specialty": "General ",
              "Value": "2",
              "Expanded Value": "Congestive heart failure, NYHA class II, per problem list ",
              "Page": "219"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "cardiomyopathy ",
              "Feature": "ICD placement ",
              "Report Date": "05/12/2015",
              "Event Date": "12/08/2010",
              "Clinician Name": "Clark McKenzia, MD ",
              "Clinician Specialty": "General ",
              "Value": "Yes ",
              "Expanded Value": "Defibrillator, implanted on 12/08/2010 ",
              "Page": "219"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "heart failure ",
              "Feature": "Heart failure type ",
              "Report Date": "05/12/2015",
              "Event Date": "01/01/1900",
              "Clinician Name": "Clark McKenzia, MD ",
              "Clinician Specialty": "General ",
              "Value": "CHF ",
              "Expanded Value": "Congestive heart failure, NYHA class II, per problem list ",
              "Page": "219"
            },
            {
              "Impairment Category": "No Match ",
              "Impairment": "CAD ",
              "Feature": "In medical history only ",
              "Report Date": "03/17/2014 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "> 1 mention ",
              "Expanded Value": "CAD-controlled, per assessment ",
              "Page": "251"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Feature": "Dementia Type ",
              "Report Date": "03/17/2014 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Alzheimer's ",
              "Expanded Value": "Alzheimer's disease- controlled, per assessment ",
              "Page": "251"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "memory loss ",
              "Feature": "Memory loss ",
              "Report Date": "03/25/2013 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "no details ",
              "Expanded Value": "Memory loss, seems to be progressing, per HPI ",
              "Page": "1"
            },
            {
              "Impairment Category": "No Match ",
              "Impairment": "CAD ",
              "Feature": "In medical history only ",
              "Report Date": "09/28/2012 ",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "> 1 mention ",
              "Expanded Value": "CAD, unspecified- stable ",
              "Page": "9"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Feature": "Dementia Type ",
              "Report Date": "09/28/2012 ",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "Alzheimer's ",
              "Expanded Value": "Alzheimer's disease, fair control ",
              "Page": "9"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Dementia ",
              "Feature": "Cognitive impairment manifestations ",
              "Report Date": "03/27/2012 ",
              "Event Date": "",
              "Clinician Name": "Clark R ***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Memory issues ",
              "Expanded Value": "Dementia with moderate to advanced memory loss ",
              "Page": "53"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Dementia ",
              "Feature": "Judgment ",
              "Report Date": "09/08/2011",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "poor judgment ",
              "Expanded Value": "Has difficulty with judgement and directions, per HPI ",
              "Page": "19"
            },
            {
              "Impairment Category": "Pulmonary ",
              "Impairment": "Sleep apnea ",
              "Feature": "Obstructive sleep apnea ",
              "Report Date": "09/08/2011",
              "Event Date": "01/01/1900",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "Yes ",
              "Expanded Value": "He did have OSA on sleep studies in past, but declined the CPAP, per HPI ",
              "Page": "19"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "MI ",
              "Feature": "Type of heart attack ",
              "Report Date": "09/08/2011",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "anterior ",
              "Expanded Value": "Anterior MI anterior wall, unspecified, chronic, stable at present ",
              "Page": "22"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Dementia ",
              "Feature": "Cognitive impairment manifestations ",
              "Report Date": "09/08/2011",
              "Event Date": "09/08/2010",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "forgetfulness ",
              "Expanded Value": "His wife says that he had major decline in last year, he forgets to prepare his lunch for example, per HPI ",
              "Page": "19"
            },
            {
              "Impairment Category": "Pulmonary ",
              "Impairment": "Sleep apnea ",
              "Feature": "Treatment for sleep apnea ",
              "Report Date": "09/08/2011",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "no treatment ",
              "Expanded Value": "He did have OSA on sleep studies in past, but declined the CPAP, per HPI ",
              "Page": "19"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Feature": "Dementia Type ",
              "Report Date": "09/08/2011",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "Alzheimer's ",
              "Expanded Value": "Alzheimer's disease, chronic ",
              "Page": "22"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Feature": "# Stents Placed ",
              "Report Date": "03/08/2011",
              "Event Date": "01/01/1900",
              "Clinician Name": "Clark ***, MD ",
              "Clinician Specialty": "General ",
              "Value": "unspecified ",
              "Expanded Value": "CAD with previous anterior MI-LAD stenting ",
              "Page": "64"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "cardiomyopathy ",
              "Feature": "ICD placement ",
              "Report Date": "12/08/2010",
              "Event Date": "",
              "Clinician Name": "Stephen J Pieper, MD ",
              "Clinician Specialty": "General ",
              "Value": "Yes ",
              "Expanded Value": "Status post single chamber ICD implantation, successful ICD single chamber implant, noted from operative report ",
              "Page": "130- 131 "
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "memory loss ",
              "Feature": "Memory loss ",
              "Report Date": "09/09/2010",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "short-term ",
              "Expanded Value": "Seems more aware of his short term memory problem ",
              "Page": "27"
            },
            {
              "Impairment Category": "Valvular heart disease ",
              "Impairment": "Heart murmur ",
              "Feature": "Grade ",
              "Report Date": "08/16/2010 ",
              "Event Date": "",
              "Clinician Name": "Dr *** ",
              "Clinician Specialty": "General ",
              "Value": "01-Jun",
              "Expanded Value": "I/VI parasternal systolic murmur ",
              "Page": "122"
            },
            {
              "Impairment Category": "Valvular heart disease ",
              "Impairment": "Heart murmur ",
              "Feature": "Grade ",
              "Report Date": "08/16/2010 ",
              "Event Date": "",
              "Clinician Name": "Dr *** ",
              "Clinician Specialty": "General ",
              "Value": "systolic ",
              "Expanded Value": "I/VI parasternal systolic murmur ",
              "Page": "122"
            },
            {
              "Impairment Category": "No Match ",
              "Impairment": "MI ",
              "Feature": "In medical history only ",
              "Report Date": "08/16/2010 ",
              "Event Date": "",
              "Clinician Name": "Dr *** ",
              "Clinician Specialty": "General ",
              "Value": "> 1 mention ",
              "Expanded Value": "Acute myocardial infarction ",
              "Page": "121"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "heart failure ",
              "Feature": "NYHA Class ",
              "Report Date": "08/16/2010 ",
              "Event Date": "01/01/1900",
              "Clinician Name": "Dr *** ",
              "Clinician Specialty": "General ",
              "Value": "2",
              "Expanded Value": "Class Il compensated CHF, per PMH ",
              "Page": "121"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Arrhythmias ",
              "Feature": "Arrhythmias Type ",
              "Report Date": "08/16/2010 ",
              "Event Date": "",
              "Clinician Name": "Dr *** ",
              "Clinician Specialty": "General ",
              "Value": "PVCs ",
              "Expanded Value": "Frequent PVCs, per impression ",
              "Page": "122"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "cardiomyopathy ",
              "Feature": "Cardiomyopathy Type ",
              "Report Date": "08/16/2010 ",
              "Event Date": "",
              "Clinician Name": "Dr *** ",
              "Clinician Specialty": "General ",
              "Value": "Ischemic Cardiomyopathy (ICM) ",
              "Expanded Value": "Persistent ischemic cardiomyopathy, severe, in setting of known coronary disease, compensated class II heart failure and frequent PVCs, per impression ",
              "Page": "121"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "heart failure ",
              "Feature": "Heart failure type ",
              "Report Date": "08/16/2010 ",
              "Event Date": "01/01/1900",
              "Clinician Name": "Dr *** ",
              "Clinician Specialty": "General ",
              "Value": "CHF ",
              "Expanded Value": "Class II compensated CHF, per PMH ",
              "Page": "121"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "MCI ",
              "Feature": "Cognitive impairment manifestations ",
              "Report Date": "04/27/2010 ",
              "Event Date": "",
              "Clinician Name": "David J Ban, MD ",
              "Clinician Specialty": "General ",
              "Value": "Memory issues ",
              "Expanded Value": "Mild cognitive impairment, controlled, memory is not getting any better ",
              "Page": "34"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Feature": "# Stents Placed ",
              "Report Date": "04/13/2010 ",
              "Event Date": "",
              "Clinician Name": "Clark ***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Unspecified ",
              "Expanded Value": "Coronary artery disease, status post left anterior descending angioplasty and stenting (primary reperfusion), per ",
              "Page": "156"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "CAD ",
              "Feature": "Other surgical procedures ",
              "Report Date": "04/13/2010 ",
              "Event Date": "",
              "Clinician Name": "Clark ***, MD ",
              "Clinician Specialty": "General ",
              "Value": "angioplasty ",
              "Expanded Value": "Coronary artery disease, status post left anterior descending angioplasty and stenting (primary reperfusion), per discharge diagnoses. ",
              "Page": "156"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "MI ",
              "Feature": "Type of heart attack ",
              "Report Date": "04/13/2010 ",
              "Event Date": "",
              "Clinician Name": "Clark ***, MD ",
              "Clinician Specialty": "General ",
              "Value": "anterior ",
              "Expanded Value": "Anterior wall myocardial infarction, per discharge diagnoses ",
              "Page": "156"
            },
            {
              "Impairment Category": "CAD/Cardiovascular ",
              "Impairment": "Arrhythmias ",
              "Feature": "Arrhythmias Type ",
              "Report Date": "04/13/2010 ",
              "Event Date": "",
              "Clinician Name": "Clark ***, MD ",
              "Clinician Specialty": "General ",
              "Value": "tachycardia ",
              "Expanded Value": "Non sustained ventricular tachycardia, per discharge diagnoses ",
              "Page": "156"
            },
            {
              "Impairment Category": "Blood Disorders ",
              "Impairment": "Thrombocytopenia ",
              "Feature": "Type of Thrombocytopenia ",
              "Report Date": "04/13/2010 ",
              "Event Date": "",
              "Clinician Name": "Clark ***, MD ",
              "Clinician Specialty": "General ",
              "Value": "not stated ",
              "Expanded Value": "Mild thrombocytopenia, per discharge diagnoses ",
              "Page": "156"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Feature": "Dementia Type ",
              "Report Date": "04/10/2010",
              "Event Date": "01/01/1900",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "senile dementia ",
              "Expanded Value": "Senile dementia of the Alzheimer's type, per PHH ",
              "Page": "167"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "cognitive impairment ",
              "Feature": "Cognitive impairment manifestations ",
              "Report Date": "09/10/2009",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "word finding issues ",
              "Expanded Value": "Does have some occasional word finding difficulties and having some occasional difficulty with language comprehension, per HPI ",
              "Page": "71"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "memory loss ",
              "Feature": "Memory loss ",
              "Report Date": "09/10/2009",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "short-term ",
              "Expanded Value": "In regards to short term memory, he would forget new information in a conversation, per HPI ",
              "Page": "71"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "memory loss ",
              "Feature": "Memory loss ",
              "Report Date": "09/10/2009",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "forgetfulness ",
              "Expanded Value": "In regards to short term memory, he would forget new information in a conversation, per HPI ",
              "Page": "71"
            },
            {
              "Impairment Category": "Blood Disorders ",
              "Impairment": "Anemia ",
              "Feature": "Anemia Type ",
              "Report Date": "09/10/2009",
              "Event Date": "01/01/1900",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Unspecified ",
              "Expanded Value": "There is a remote history of anemia, per PMH ",
              "Page": "71"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Alzheimer's ",
              "Feature": "Dementia Type ",
              "Report Date": "09/10/2009",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Alzheimer's ",
              "Expanded Value": "Possible early dementia of the Alzheimer's type per assessment ",
              "Page": "73"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "Dementia ",
              "Feature": "Dementia Type ",
              "Report Date": "09/10/2009",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "Alzheimer's ",
              "Expanded Value": "Possible early dementia of the Alzheimer's type per assessment ",
              "Page": "73"
            },
            {
              "Impairment Category": "Neurological ",
              "Impairment": "memory loss ",
              "Feature": "Memory loss ",
              "Report Date": "07/30/2009 ",
              "Event Date": "",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "no details ",
              "Expanded Value": "Memory loss, patient has been on Aricept at night, Namenda 10mg bid and Lexapro per reason for visit ",
              "Page": "41"
            },
            {
              "Impairment Category": "Gastrointestinal ",
              "Impairment": "GERD ",
              "Feature": "Gastrointestinal disorders ",
              "Report Date": "06/18/2009 ",
              "Event Date": "01/01/1900",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "GERD ",
              "Expanded Value": "Esophageal reflux. Status: Controlled, per chronic problems ",
              "Page": "44"
            },
            {
              "Impairment Category": "Gastrointestinal ",
              "Impairment": "diverticulitis ",
              "Feature": "Gastrointestinal disorders ",
              "Report Date": "06/18/2009 ",
              "Event Date": "01/01/2004",
              "Clinician Name": "***, MD ",
              "Clinician Specialty": "General ",
              "Value": "diverticulitis ",
              "Expanded Value": "Diverticulitis, 2004 status post sigmoid colectomy, per ",
              "Page": "44"
            }
           ]
    },
    "generalInfo": {
      "Name": '****',
      "Gender": 'Male',
      "Age": '85', 
      "DOB": '02/15/1937', 
      "Medical Records Start Date": "06/18/2009",
      "Medical Records End Date": "05/29/2015",
      "Marital Status": "Married",
      "Address": "",
      "State": '', 
      "SSN": '*******',
      "heigh": "5'9\" (05/29/2015)",
      "Weight": "199Lbs (05/29/2015)",
      "BMI": '29.38', 
      "Smoker": 'Non-Smoker',
      "Life Expectancy Mean": '78 Month',
      "Life Expectancy Median": '81 Month'
    },
    "le": {
      "dies": [7, 8, 10, 10, 10, 9, 9, 8, 7, 5, 5, 4, 3, 2, 1, 1, 1],
      "lives": [100, 93, 85, 75, 65, 55, 46, 37, 29, 22, 17, 12, 8, 5, 3, 2, 1]
    }, 
    "Troubleshooting": [
      {
        "File Name": "2013 - Dr. B",
        "Page Number": "2",
        "Problem": "Hand Writing",
        "Severity": "Low"
      },
      {
        "File Name": "2013 - Dr. B",
        "Page Number": "19",
        "Problem": "Hand Writing",
        "Severity": "Medium"
      },
      {
        "File Name": "2013 - Dr. B",
        "Page Number": "2-9",
        "Problem": "Poor Scan",
        "Severity": "Medium"
      },
      {
        "File Name": "2013 - Dr. B",
        "Page Number": "26",
        "Problem": "Unidentified",
        "Severity": "Medium"
      },
      {
        "File Name": "2013 - Dr. B",
        "Page Number": "37",
        "Problem": "Unidentified",
        "Severity": "Medium"
      },
      {
        "File Name": "2013 - Dr. B",
        "Page Number": "52",
        "Problem": "Hand Writing",
        "Severity": "Low"
      },
      {
        "File Name": "2013 - Dr. B",
        "Page Number": "132",
        "Problem": "Unidentified",
        "Severity": "Low"
      },
      {
        "File Name": "2013 - Dr. M",
        "Page Number": "132",
        "Problem": "Hand Writing",
        "Severity": "Low"
      },
      {
        "File Name": "2015 08 05 - Dr. B",
        "Page Number": "96",
        "Problem": "Unidentified",
        "Severity": "Medium"
      },
      {
        "File Name": "2015 08 05 - Dr. B",
        "Page Number": "79-96",
        "Problem": "Poor Scan",
        "Severity": "Low"
      },
      {
        "File Name": "2015 08 05 - Dr. B",
        "Page Number": "101",
        "Problem": "Unidentified",
        "Severity": "Medium"
      },
      {
        "File Name": "2015 08 05 - Dr. B",
        "Page Number": "137",
        "Problem": "Unidentified",
        "Severity": "High"
      },
      {
        "File Name": "2015 08 05 - Dr. B",
        "Page Number": "104-111",
        "Problem": "Poor Scan",
        "Severity": "Low"
      },
      {
        "File Name": "Dr. B",
        "Page Number": "1",
        "Problem": "Hand Writing",
        "Severity": "Low"
      },
      {
        "File Name": "Dr. B",
        "Page Number": "2",
        "Problem": "Hand Writing",
        "Severity": "Low"
      }
     ]
}
